export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const APPEND_ALBUMS = 'APPEND_ALBUMS';
export const APPEND_FEATURES = 'APPEND_FEATURES';
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';
export const GET_ALBUMS = 'GET_ALBUMS';
export const GET_ARTISTS = 'GET_ARTISTS';
export const GET_FEATURES = 'GET_FEATURES';
export const GET_GENRES = 'GET_GENRES';
export const GET_LABELS = 'GET_LABELS';
export const RESET_SELECTED_ALBUM = 'RESET_SELECTED_ALBUM';
export const RESET_SELECTED_ARTIST = 'RESET_SELECTED_ARTIST';
export const RESET_SELECTED_FEATURE = 'RESET_SELECTED_FEATURE';
export const RESET_SELECTED_GENRES = 'RESET_SELECTED_GENRES';
export const RESET_SELECTED_LABELS = 'RESET_SELECTED_LABELS';
export const APPEND_ALL_REVIEWS = 'APPEND_ALL_REVIEWS';
export const APPEND_LEGACY_REVIEWS = 'UPDATE_LEGACY_REVIEWS';
export const APPEND_RECENT_REVIEWS = 'UPDATE_RECENT_REVIEWS';
export const SAVE_ALBUM = 'SAVE_ALBUM';
export const SAVE_FEATURE = 'SAVE_FEATURE';
export const SET_ALBUMS = 'SET_ALBUMS';
export const SET_ALL_ALBUMS_LOADED = 'SET_ALL_ALBUMS_LOADED';
export const SET_ALL_FEATURES_LOADED = 'SET_ALL_FEATURES_LOADED';
export const SET_ALL_REVIEWS = 'SET_ALL_REVIEWS';
export const SET_FEATURES = 'SET_FEATURES';
export const SET_FEATURE_CATEGORIES = 'SET_FEATURE_CATEGORIES';
export const SET_IMPERSONATION_USER = 'SET_IMPERSONATION_USER';
export const SET_IS_AUTHENTICATING = 'SET_IS_AUTHENTICATING';
export const SET_IS_FETCHING_FEATURES = 'SET_IS_FETCHING_FEATURES';
export const SET_IS_FETCHING_RECENT_ALBUMS = 'SET_IS_FETCHING_RECENT_ALBUMS';
export const SET_LAST_ALBUM_DOCUMENT = 'SET_LAST_ALBUM_DOCUMENT';
export const SET_LAST_FEATURE_DOCUMENT = 'SET_LAST_FEATURE_DOCUMENT';
export const SET_LAST_REVIEW_DOCUMENT = 'SET_LAST_REVIEW_DOCUMENT';
export const SET_LEGACY_REVIEWS = 'SET_LEGACY_REVIEWS';
export const SET_RECENT_REVIEWS = 'SET_RECENT_REVIEWS';
export const SET_IS_MODAL_OPEN = 'SET_IS_MODAL_OPEN';
export const SET_SELECTED_ALBUM = 'SET_SELECTED_ALBUM';
export const SET_SELECTED_ARTIST = 'SET_SELECTED_ARTIST';
export const SET_SELECTED_FEATURE = 'SET_SELECTED_FEATURE';
export const SET_SELECTED_GENRES = 'SET_SELECTED_GENRES';
export const SET_SELECTED_LABELS = 'SET_SELECTED_LABELS';
export const SET_USERS = 'SET_USERS';
